// app/javascript/components/shared/ui/IconBadge.js
//
// Small filled square / circle housing a single icon (FontAwesome). Used
// as a row-level type indicator (product / labour) and as the leading
// avatar on modal headers and list rows.
import React from "react"
import { cva } from "class-variance-authority"
import clsx from "clsx"

export const iconBadgeVariants = cva(
  "inline-grid place-items-center shrink-0",
  {
    variants: {
      tone: {
        neutral: "bg-slate-100 text-slate-500",
        brand:   "bg-brand-50 text-brand-600",
        group:   "bg-group-50 text-group-500",
        section:    "bg-section-50 text-section-500",
        subsection: "bg-subsection-50 text-subsection-500",
        labour:  "bg-amber-50 text-amber-700",
        product: "bg-brand-50 text-brand-600",
        blue:    "bg-blue-50 text-blue-700",
        emerald: "bg-emerald-50 text-emerald-700",
        amber:   "bg-amber-50 text-amber-700",
        violet:  "bg-violet-50 text-violet-700",
        rose:    "bg-rose-50 text-rose-700",
        slate:   "bg-slate-100 text-slate-700",
      },
      size: {
        xs: "w-[20px] h-[20px] text-[10px]",
        sm: "w-[22px] h-[22px] text-[10.5px]",
        md: "w-7 h-7 text-[12px]",
        lg: "w-9 h-9 text-[14px]",
      },
      shape: {
        square: "rounded-md",
        circle: "rounded-full",
      },
    },
    defaultVariants: { tone: "neutral", size: "sm", shape: "square" },
  }
)

const IconBadge = ({ tone, size, shape, className, as: Tag = "span", ...props }) => (
  <Tag className={clsx(iconBadgeVariants({ tone, size, shape }), className)} {...props} />
)

export default IconBadge
